import { render } from "./GrupoSelect.vue?vue&type=template&id=00aafeb4"
import script from "./GrupoSelect.vue?vue&type=script&lang=js"
export * from "./GrupoSelect.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-cliente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__